'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseBreakpoint = exports.addDefaultBreakpoint = exports.findBreakpointByName = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _ramda = require('ramda');

var _breakpoints = require('../const/breakpoints');

var _errors = require('../errors');

var _predicate = require('./predicate');

var _range = require('./range');

var firstCharIsModifier = function firstCharIsModifier(value) {
  return (0, _ramda.any)((0, _ramda.equals)(value[0]), _breakpoints.MODIFIERS);
};

var findBreakpointByName = exports.findBreakpointByName = function findBreakpointByName(breakpointMap, name) {
  return (0, _ramda.compose)(_ramda.last, (0, _ramda.find)((0, _ramda.compose)((0, _ramda.equals)(name), _ramda.head)))(breakpointMap, name);
};

var addDefaultBreakpoint = exports.addDefaultBreakpoint = (0, _ramda.prepend)([_breakpoints.DEFAULT_BREAKPOINT_NAME, 0]);

var extractOffset = function extractOffset(value) {
  if ((0, _predicate.hasPositiveOffset)(value)) {
    return (0, _ramda.split)(_breakpoints.POSITIVE_OFFSET, value);
  }
  if ((0, _predicate.hasNegativeOffset)(value)) {
    var _split = (0, _ramda.split)(_breakpoints.NEGATIVE_OFFSET, value),
        _split2 = _slicedToArray(_split, 2),
        name = _split2[0],
        offset = _split2[1];

    return [name, '-' + offset];
  }
  return [value];
};

var createRangeItem = function createRangeItem(value) {
  var modifier = firstCharIsModifier(value) ? (0, _ramda.head)(value) : null;
  if (modifier) value = (0, _ramda.tail)(value);

  var _extractOffset = extractOffset(value),
      _extractOffset2 = _slicedToArray(_extractOffset, 2),
      name = _extractOffset2[0],
      offset = _extractOffset2[1];

  var result = {
    name: name,
    offset: offset,
    modifier: modifier
  };

  return (0, _ramda.reject)(_ramda.isNil, result);
};

var parseBreakpoint = exports.parseBreakpoint = function parseBreakpoint(value) {
  if (!(0, _predicate.isValidModifiedMq)(value)) {
    throw Error((0, _errors.invalidBreakpointSyntaxError)(value));
  }

  // A range will always have a < in a position greater than 0
  if (!(0, _range.isRange)(value)) {
    // It's a single item
    return {
      name: value,
      range: [createRangeItem(value)]
    };
  }

  // Otherwise it's a range (containing two items)
  var values = (0, _ramda.split)(_breakpoints.LT_MODIFIER, value);
  var firstRangeItem = createRangeItem(values[0]);
  var secondRangeItem = createRangeItem(values[1]);
  return { name: value, range: [firstRangeItem, secondRangeItem] };
};


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/utils/breakpoints.js
// module id = 344
// module chunks = 168707334958949